import api from './api';

const BASE_URL = '/bills';

class BillService {
  constructor() {
    this.httpClient = api;
  }

  async billListByTypeAndPeriod({ period, type }) {
    try {
      const response = await this.httpClient.get(BASE_URL, {
        params: {
          type,
          startDate: period?.[0],
          endDate: period?.[1],
        },
      });
      return await response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      throw new Error(errorMessage);
    }
  }

  async billsAmount({ period, type }) {
    try {
      const response = await this.httpClient.get(`${BASE_URL}/amount`, {
        params: {
          type,
          startDate: period?.[0],
          endDate: period?.[1],
        },
      });
      return await response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      throw new Error(errorMessage);
    }
  }

  async billsExport({ period, type }) {
    try {
      const response = await this.httpClient.get(`${BASE_URL}/export`, {
        params: {
          type,
          startDate: period?.[0],
          endDate: period?.[1],
        },
      });
      return await response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      throw new Error(errorMessage);
    }
  }
}

export default new BillService();
